<template>
  <div class="panel">
    <h3>Registro de Asistentes</h3>
    <form @submit.prevent="registrar" class="formulario">
      <input v-model="nuevo.name" placeholder="Nombre" required />
      <input v-model="nuevo.phone" placeholder="Teléfono" />
      <input v-model="nuevo.email" placeholder="Email" />
      <select v-model="nuevo.interest" required @change="onInterestChange">
        <option v-for="int in intereses" :key="int" :value="int.toLowerCase()">
          {{ capitalizar(int) }}
        </option>
      </select>
      <input v-if="nuevo.interest === 'otro'" v-model="nuevo.other_interest" placeholder="Especifica otro interés" required />
      <textarea v-model="nuevo.note" placeholder="Nota"></textarea>

      <div class="botones-form">
        <button type="submit" class="btn-registrar">Registrar</button>
        <button type="button" class="btn-secundario" @click="mostrarRegistros = !mostrarRegistros">
          {{ mostrarRegistros ? 'Ocultar Registros' : 'Mostrar Registros' }}
        </button>
        <button type="button" class="btn-salir" @click="salir">Salir</button>
      </div>
      <div v-if="success" class="success-msg">¡Registrado!</div>
      <div v-if="errorMsg" class="error-msg">{{ errorMsg }}</div>
    </form>

    <button @click="descargar" class="btn-descargar">Descargar CSV</button>

    <div class="tabla-contenedor" v-if="mostrarRegistros" ref="tablaCont">
      <table :class="{ 'tabla-amplia': pantallaGrande }">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Teléfono</th>
            <th>Email</th>
            <th>Interés</th>
            <th>Nota</th>
            <th>Fecha</th>
            <th>Seguimiento</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="a in asistentes" :key="a.id">
            <td>{{ a.name }}</td>
            <td>{{ a.phone }}</td>
            <td>{{ a.email }}</td>
            <td>{{ a.interest === 'otro' && a.other_interest ? a.other_interest : capitalizar(a.interest) }}</td>
            <td>{{ a.note }}</td>
            <td>{{ a.created_at ? a.created_at.slice(0,10) : '' }}</td>
            <td>
              <span v-if="a.was_attended == 1">✔ {{ a.attended_how ? capitalizar(a.attended_how) : '' }}<br/>
                {{ a.attended_by ? 'Por: ' + a.attended_by : '' }}<br/>
                {{ a.attended_date ? 'Fecha: ' + a.attended_date.slice(0,10) : '' }}
              </span>
              <span v-else>No</span>
              <div v-if="a.followup_type && a.followup_type !== 'ninguno'">
                <small>
                  <b>Próx:</b> {{ capitalizar(a.followup_type) }}
                  {{ a.followup_date ? '(' + a.followup_date.slice(0,10) + ')' : '' }}
                  <span v-if="a.followup_note">- {{ a.followup_note }}</span>
                </small>
              </div>
            </td>
            <td>
              <button @click="abrirSeguimiento(a)">Seguimiento</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="role === 'stand'" class="qr-contenedor">
      <h4>QR para tu stand:</h4>
      <img :src="qrUrl" alt="QR Stand" style="max-width:180px; margin-bottom:10px;">
      <button @click="abrirQR">Abrir QR en nueva pestaña</button>
    </div>

    <div v-if="showSeguimiento" class="modal-fondo">
      <div class="modal">
        <h4>Seguimiento: {{ asistenteActual.name }}</h4>
        <label>¿Atendido?</label>
        <select v-model="asistenteActual.was_attended">
          <option :value="1">Sí</option>
          <option :value="0">No</option>
        </select>
        <template v-if="Number(asistenteActual.was_attended) === 1">
          <label>¿Cómo?</label>
          <select v-model="asistenteActual.attended_how">
            <option value="">-Selecciona-</option>
            <option value="llamada">Llamada</option>
            <option value="visita">Visita</option>
            <option value="correo">Correo</option>
            <option value="otro">Otro</option>
          </select>
          <label>¿Quién atendió?</label>
          <input v-model="asistenteActual.attended_by" />
          <label>Fecha de atención</label>
          <input type="date" v-model="asistenteActual.attended_date" />
        </template>
        <label>Tipo de seguimiento</label>
        <select v-model="asistenteActual.followup_type">
          <option value="ninguno">Ninguno</option>
          <option value="llamada">Llamada</option>
          <option value="visita">Visita</option>
          <option value="correo">Correo</option>
        </select>
        <label>Fecha seguimiento</label>
        <input type="date" v-model="asistenteActual.followup_date" />
        <label>Nota seguimiento</label>
        <textarea v-model="asistenteActual.followup_note"></textarea>
        <div style="margin-top:12px">
          <button @click="guardarSeguimiento" :disabled="guardando">
            {{ guardando ? "Guardando..." : "Guardar" }}
          </button>
          <button @click="showSeguimiento=false">Cancelar</button>
        </div>
      </div>
    </div>
  <div class="footer">
      © {{ new Date().getFullYear() }} Pulso Agrícola | Todos los derechos reservados
    </div>

  </div>
</template>

<script>
import axios from 'axios'
export default {
  props: ['token', 'role', 'stand_id', 'intereses'],
  data() {
    return {
      asistentes: [],
      nuevo: { name: '', phone: '', email: '', interest: '', other_interest: '', note: '' },
      asistenteActual: null,
      showSeguimiento: false,
      guardando: false,
      success: false,
      errorMsg: "",
      mostrarRegistros: false,
      pantallaGrande: window.innerWidth > 900,
    }
  },
  mounted() {
    this.cargar();
    window.addEventListener('resize', this.verificarPantalla);
    this.verificarPantalla();
  },
  methods: {
    capitalizar(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : ""; },
    async cargar() {
      const res = await axios.get('/api/attendees', { headers: { Authorization: 'Bearer ' + this.token } })
      this.asistentes = res.data
    },
    async registrar() {
      this.success = false; this.errorMsg = ""
      if (this.nuevo.interest === 'otro' && !this.nuevo.other_interest) {
        this.errorMsg = 'Por favor, especifica el otro interés.'; return;
      }
      try {
        await axios.post('/api/attendees', this.nuevo, { headers: { Authorization: 'Bearer ' + this.token } })
        this.success = true
        this.nuevo = { name: '', phone: '', email: '', interest: '', other_interest: '', note: '' }
        await this.cargar()
        setTimeout(() => (this.success = false), 1700)
      } catch (e) {
        this.errorMsg = "Error al registrar"
      }
    },
    onInterestChange() {
      if (this.nuevo.interest !== 'otro') this.nuevo.other_interest = ''
    },
    abrirSeguimiento(a) {
      this.asistenteActual = { ...a }
      this.showSeguimiento = true
    },
    async guardarSeguimiento() {
      this.guardando = true
      await axios.put('/api/attendees/' + this.asistenteActual.id, this.asistenteActual, { headers: { Authorization: 'Bearer ' + this.token } })
      this.showSeguimiento = false
      await this.cargar()
      this.guardando = false
    },
    async descargar() {
      const res = await axios.get('/api/attendees/export', { headers: { Authorization: 'Bearer ' + this.token }, responseType: 'blob' })
      const url = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'asistentes_stand.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    verificarPantalla() {
      this.pantallaGrande = window.innerWidth > 900;
    },
    abrirQR() {
      const url = `${window.location.origin}/registro/${this.stand_id}`;
      const qrApi = `https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${encodeURIComponent(url)}`;
      window.open(qrApi, '_blank');
    },
    salir() {
      this.$emit('salir')
    }
  },
  computed: {
    qrUrl() {
      const url = `${window.location.origin}/registro/${this.stand_id}`;
      return `https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${encodeURIComponent(url)}`;
    }
  }
}
</script>

<style scoped>
.panel {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px #0001;
  padding: 18px 7px 22px 7px;
  margin-top: 8px;
  max-width: 410px;
  margin-left: auto;
  margin-right: auto;
}
.formulario {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 370px;
  margin: auto;
}
.botones-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 16px;
}
.btn-registrar, .btn-secundario, .btn-salir {
  width: 100%;
  padding: 13px 0;
  border: none;
  border-radius: 7px;
  font-weight: bold;
  font-size: 1.09em;
}
.btn-registrar, .btn-secundario {
  background: #0078d4;
  color: white;
}
.btn-secundario {
  background: #0365ad;
}
.btn-salir {
  background: #e43d3d;
  color: white;
}
.success-msg {
  color: #22bb55;
  font-weight: bold;
  text-align: center;
  margin-top: 7px;
}
.error-msg {
  color: #e43d3d;
  font-weight: bold;
  text-align: center;
  margin-top: 7px;
}
.btn-descargar {
  margin: 18px auto 6px auto;
  display: block;
  padding: 11px 0;
  width: 95%;
  background: #278C27;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: bold;
  font-size: 1.05em;
}
.tabla-contenedor {
  overflow-x: auto;
  margin-top: 20px;
}
table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.97em;
}
.tabla-amplia {
  font-size: 1.05em;
}
th, td {
  padding: 6px 10px;
  border: 1px solid #eee;
  text-align: left;
}
th {
  position: sticky;
  top: 0;
  background: #f9f9f9;
  z-index: 2;
}
.modal-fondo {
  position: fixed;
  left:0; top:0; right:0; bottom:0;
  background:rgba(0,0,0,0.35);
  display:flex;
  justify-content:center;
  align-items:center;
  z-index:1001;
}
.modal {
  background:#fff;
  border-radius:8px;
  padding:20px;
  min-width:300px;
  box-shadow:0 2px 8px #0002;
  max-width: 94vw;
}
.qr-contenedor {
  margin-top: 25px;
  text-align: center;
}
@media (max-width: 600px) {
  .panel { max-width: 98vw; }
  .formulario { max-width: 96vw; }
  table, th, td { font-size: 0.93em; }
}
.footer {
  text-align: center;
  font-size: 0.85em;
  color: #666;
  margin-top: 25px;
  padding-top: 10px;
  border-top: 1px solid #ddd;
}




</style>
